import React, { useState, useEffect } from 'react';
import { adminGetContacts } from '../../api';

function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    adminGetContacts()
      .then(res => setContacts(res.data))
      .catch(() => setContacts([]));
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Messages de contact</h2>
        <span style={{ color: 'var(--color-text-secondary)', fontSize: '14px' }}>
          {contacts.length} message{contacts.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Nom</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>SIREN</th>
              <th>Société</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {contacts.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: 'center' }}>Aucun message reçu</td></tr>
            ) : (
              contacts.map(c => (
                <React.Fragment key={c.id}>
                  <tr
                    style={{ cursor: c.message ? 'pointer' : 'default' }}
                    onClick={() => c.message && setExpanded(expanded === c.id ? null : c.id)}
                  >
                    <td className="num" style={{ whiteSpace: 'nowrap' }}>
                      {new Date(c.created_at + 'Z').toLocaleString('fr-FR')}
                    </td>
                    <td>{c.nom}</td>
                    <td>
                      <a href={`mailto:${c.email}`} style={{ color: 'var(--color-primary)' }}>
                        {c.email}
                      </a>
                    </td>
                    <td>{c.telephone || '—'}</td>
                    <td className="num">{c.siren || '—'}</td>
                    <td>{c.raison_sociale || '—'}</td>
                    <td style={{ maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: 'var(--color-text-secondary)' }}>
                      {c.message
                        ? <span>{expanded === c.id ? '▲' : '▼'} {c.message}</span>
                        : '—'}
                    </td>
                  </tr>
                  {expanded === c.id && (
                    <tr>
                      <td colSpan="7" style={{ background: 'var(--color-bg-alt, #f8fafc)', padding: '12px 16px', borderTop: 'none' }}>
                        <div style={{ whiteSpace: 'pre-wrap', fontSize: '14px', color: 'var(--color-text)' }}>
                          {c.message}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminContacts;
